// Actions
import {
  SET_PROSPECTIVE_STUDENTS_QUERY,
  SET_PARENTS_OF_PROSPECTS_QUERY,
  SET_OTHER_QUERY,
  SET_USA_QUERY,
  SET_INTERNATIONAL_QUERY,
  SET_AGE_QUERY,
  SET_GENDER_QUERY,
  SET_ETHNICITY_QUERY,
  SET_INTENDED_LEVEL_OF_STUDY_QUERY,
  SET_ENTRY_TERM_QUERY,
  SET_INTENDED_MAJOR_QUERY,
  SET_GPA_QUERY,
  SET_TEST_SCORES_QUERY,
  SET_DATE_REGISTERED_QUERY,
  SET_RELATIVE_ENGAGEMENT_QUERY,
  SET_TOTAL_TIME_SPENT_QUERY,
  SET_SCHEDULED_VISIT_QUERY,
  SET_APPLIED_QUERY,
  SET_ACTIVITY_WITH_INSTITUTION_QUERY,
  SET_ACTIVITY_WITH_EAB_QUERY,
  SET_LIST_MEMBERSHIP_QUERY,
  SET_LOCATIONS_QUERY,
  SET_QUERY_IS_INCONGRUENT,
} from '../actionTypes/query.actionTypes';

// Classes
import { QueryReducerState } from '../classes/query.classes';

const initialState = new QueryReducerState();

export const QueryReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_PROSPECTIVE_STUDENTS_QUERY:
      return { ...state, prospectiveStudentsQuery: action.payload };
    case SET_PARENTS_OF_PROSPECTS_QUERY:
      return { ...state, parentsOfProspectsQuery: action.payload };
    case SET_OTHER_QUERY:
      return { ...state, otherQuery: action.payload };
    case SET_USA_QUERY:
      return { ...state, usaQuery: action.payload };
    case SET_INTERNATIONAL_QUERY:
      return { ...state, internationalQuery: action.payload };
    case SET_AGE_QUERY:
      return { ...state, ageQuery: action.payload };
    case SET_GENDER_QUERY:
      return { ...state, genderQuery: action.payload };
    case SET_ETHNICITY_QUERY:
      return { ...state, ethnicityQuery: action.payload };
    case SET_INTENDED_LEVEL_OF_STUDY_QUERY:
      return { ...state, intendedLevelOfStudyQuery: action.payload };
    case SET_ENTRY_TERM_QUERY:
      return { ...state, entryTermQuery: action.payload };
    case SET_INTENDED_MAJOR_QUERY:
      return { ...state, intendedMajorQuery: action.payload };
    case SET_GPA_QUERY:
      return { ...state, gpaQuery: action.payload };
    case SET_TEST_SCORES_QUERY:
      return { ...state, testScoresQuery: action.payload };
    case SET_DATE_REGISTERED_QUERY:
      return { ...state, dateRegisteredQuery: action.payload };
    case SET_RELATIVE_ENGAGEMENT_QUERY:
      return { ...state, relativeEngagementQuery: action.payload };
    case SET_TOTAL_TIME_SPENT_QUERY:
      return { ...state, totalTimeSpentQuery: action.payload };
    case SET_SCHEDULED_VISIT_QUERY:
      return { ...state, scheduledVisitQuery: action.payload };
    case SET_APPLIED_QUERY:
      return { ...state, appliedQuery: action.payload };
    case SET_ACTIVITY_WITH_INSTITUTION_QUERY:
      return { ...state, activityWithInstitutionQuery: action.payload };
    case SET_ACTIVITY_WITH_EAB_QUERY:
      return { ...state, activityWithEABQuery: action.payload };
    case SET_LIST_MEMBERSHIP_QUERY:
      return { ...state, listMembershipQuery: action.payload };
    case SET_LOCATIONS_QUERY:
      return { ...state, locationsQuery: action.payload };
    case SET_QUERY_IS_INCONGRUENT:
      return { ...state, queryIsIncongruent: action.payload };
    default:
      return state;
  }
};
